import { render, staticRenderFns } from "./o-footer.vue?vue&type=template&id=6e61d1b5&scoped=true&"
import script from "./o-footer.vue?vue&type=script&lang=js&"
export * from "./o-footer.vue?vue&type=script&lang=js&"
import style0 from "./o-footer.vue?vue&type=style&index=0&id=6e61d1b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e61d1b5",
  null
  
)

export default component.exports